module.exports = __webpack_public_path__ + "img/Singapore.011a996d.svg";